module.exports = __webpack_public_path__ + "img/yjsl_logo.81c157bf.png";